import React, { Component } from 'react';  // eslint-disable-line no-unused-vars
import Line from './Line.js';


function Block(props){

  function renderLines(){
    const {lines, block, offset} = props;

    return lines.map((line, index) => {

      //If first line of block and offset exists
      if(index === 0 && offset){
        const offText = offset.join(' ') + ' ';
        return (
          <Line
            key = {block + ' ' + index}
            className = 'line'
            offText = {offText}
          >
          {line}
          </Line>
        )
      }

      //if empty array insert linebreak
      if(line === '') return <li key={'break' + index}>&nbsp;</li>;

      return (
        <Line
          key = {block + ' ' + index}
          className = 'line'
        >
          {line}
        </Line>
      )
    });
  }

  return (
    <ul className = {props.className} id = {'block' + props.block}>
      {renderLines()}
    </ul>
  );
}



export default Block;



// WEBPACK FOOTER //
// ./src/components/Misc/Block.js